import { render, staticRenderFns } from "./CaptureImageBetterResolution.vue?vue&type=template&id=6acbe131&"
import script from "./CaptureImageBetterResolution.vue?vue&type=script&lang=js&"
export * from "./CaptureImageBetterResolution.vue?vue&type=script&lang=js&"
import style0 from "./CaptureImageBetterResolution.vue?vue&type=style&index=0&id=6acbe131&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports